
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Chess Championship </h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img
			src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
	<div class="container">
		<div class="sec-title text-center">
			<h2>Nagpur District Under <span > 11 tournament report. </span></h2>
		</div>
		<div class="row">
			<div class="col-md-12">
				<p class="text-justify">Shaunak Badole & Swara Rahul Gandhi wins Under Nagpur District Under 11 Open
					&amp; Girls Selection Chess Championship 2023</p>
				<p class="text-justify">Nagpur District Under 11 Open & Girls Selection Chess Championship 2023
					concluded on 18 June 2023, at Vivekananda Hall, Shraddha House, Kingsway ,Shri Mohini Complex
					,Nagpur. Chess Association Nagpur organized the event in association with GH Raisoni Sports and
					Cultural Foundation & Kalpana Prakash Welfare Foundation. The tournament attracted 56 players in the
					open category & 28 Players in the Girls category.</p>
				<p class="text-justify">Shaunak Badole won the championship in the open section with 7.5 points out of a
					possible 8. Swara Rahul Gandhi won the championship in the Girls section with 6 points out of a
					possible 6 .Total of 4 trophies & 26 medals were given to winners in different categories.</p>
				<p class="text-justify">1st Round Started at 10:AM.Prize Distribution ceremony was held at 04.00 PM.
					Prizes were distributed by the hands of Chief Guest Shri Shekhar Suryawanshi, Superintendent, CGST
					and Prominent Athlete of Nagpur was the Chief Guest who distributed the prizes, Other dignitaries
					present were Shri. Bhushan Shriwas Secretary Chess Association Nagpur & Kalpana Prakash Welfare
					Foundation & IA Deepak Chavan.</p>
				<p class="text-justify">Shaunak & Sahajveeer in Open Group and Swara & Yashika in Girls Group shall
					represent Nagpur District in the upcoming Maharashtra State Under-11 Chess Championship to be held
					at Pune from 28 th  to 30 th  July 2023.</p>
				<p class="text-justify">Venue for the tournament was provided by Raisoni Group and Logistic Support for
					the tournament such as Chess Sets & Chess clocks were provided by Chess Association Nagpur & Kalpana
					Prakash Welfare foundation.</p>
				<p class="text-justify">Chess results links and Prizes are attached in the mail.</p>
				<p class="text-justify">The team of Arbiters was headed by Chief Arbiter IA Deepak Chavan and he was
					ably assisted by SNA Prayas Ambade , SNA Sagar Sahare & Prathamesh Macchave worked hard to make the
					event a grand success.</p>
				<p><strong>IA Deepak Chavan</strong></p>
				<p><strong>Chief Arbiter</strong></p>
				<p><strong>Nagpur District Under 11 Open & Girls Selection Chess Championship 2023</strong></p>
				<p><strong>Chess Results Link :</strong></p>
				<p>Open :<a href="https://chess-results.com/tnr780494.aspx?lan=1&art=1&rd=7" target="_blank">
						https://chess-results.com/tnr780494.aspx?lan=1&art=1&rd=7</a></p>
				<p>Girls :<a href="https://chess-results.com/tnr780495.aspx?lan=1&art=1&rd=6"
						target="_blank">https://chess-results.com/tnr780495.aspx?lan=1&art=1&rd=6</a></p>
			</div>
			<div class="col-md-6">
				<iframe src="https://drive.google.com/file/d/1uOOj3Qdz8e49DsibIitJrsYfY2RLEI_S/preview" width="100%"
					height="600px" frameborder="0"></iframe>
			</div>
			<div class="col-md-6">
				<iframe src="https://drive.google.com/file/d/1V7Q8LPGAdplTL7P2TdkA0nGWSU5kV2cz/preview" width="100%"
					height="600px" frameborder="0"></iframe>
			</div>
			<!-- <div class="col-md-6">
				<iframe src="https://drive.google.com/file/d/1fCDVo6BeErqra43XYT__xx-rJvzcTGdD/preview" width="100%" height="600px" frameborder="0"></iframe>
			</div> -->
		</div>
		<div class="border-line-sm"></div>
	</div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
	<div class="container">
		<div class="row row-cols-1 row-cols-md-2">
			<div class="col">
				<div class="gall-ery">
					<div class="widget_title inner-title gall-sys shadow-text-sm">
						<h4 class="fw-bold">Media Coverage</h4>
					</div>

					<div class="lightBox--gallery">
						<ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour1.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour1.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour1.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour2.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour2.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour2.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour3.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour3.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour3.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour4.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour4.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour4.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour5.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour5.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/elleven-tour5.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
